module.exports = __webpack_public_path__ + "static/media/ic_ppt.d6428ca2.svg";